"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateCdnHostnames = exports.getCdnHostnameForPortal = exports.getPortalShard = exports.getFormattedShardIndex = exports.getShardDomainSuffixFromEnv = exports.constructShard = exports.SHARDS_LARGEST_INDEX = void 0;

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _enviro = _interopRequireDefault(require("enviro"));

var _Constants = require("../Constants");

var SHARDS_LARGEST_INDEX = 4;
exports.SHARDS_LARGEST_INDEX = SHARDS_LARGEST_INDEX;
var LARGEST_FORMATTED_SHARD_INDEX = 50;

var constructShard = function constructShard(apexDomainSuffix, formattedShardIndex) {
  return "f.hubspotusercontent" + apexDomainSuffix + formattedShardIndex + ".net";
};

exports.constructShard = constructShard;

var getShardDomainSuffixFromEnv = function getShardDomainSuffixFromEnv(env) {
  return env === 'prod' ? '' : 'qa';
};

exports.getShardDomainSuffixFromEnv = getShardDomainSuffixFromEnv;

var getFormattedShardIndex = function getFormattedShardIndex(index) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  if (typeof String.prototype.padEnd === 'function') {
    return String(index).padEnd(size, '0');
  } else {
    if (String(index).length >= size) {
      return String(index);
    }

    return String(index * Math.pow(10, size - 1));
  }
};

exports.getFormattedShardIndex = getFormattedShardIndex;

var getPortalShard = function getPortalShard() {
  return Math.floor(_PortalIdParser.default.get() % LARGEST_FORMATTED_SHARD_INDEX / 10);
};

exports.getPortalShard = getPortalShard;

var getCdnHostnameForPortal = function getCdnHostnameForPortal() {
  var useLegacyCdn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  if (useLegacyCdn) {
    return _Constants.CDN_DOMAINS.get(_enviro.default.getShort('filemanager')) || _Constants.CDN_DOMAINS.get('prod');
  }

  return constructShard(getShardDomainSuffixFromEnv(_enviro.default.getShort('filemanager')), getFormattedShardIndex(getPortalShard()));
};

exports.getCdnHostnameForPortal = getCdnHostnameForPortal;

var generateCdnHostnames = function generateCdnHostnames() {
  var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'prod';
  var shardApexDomainSuffix = getShardDomainSuffixFromEnv(env);
  var shardsList = new Array(SHARDS_LARGEST_INDEX + 1).fill().map(function (shard, index) {
    return constructShard(shardApexDomainSuffix, getFormattedShardIndex(index));
  });
  return shardsList;
};

exports.generateCdnHostnames = generateCdnHostnames;